import React, { useMemo } from 'react';
import styled from 'styled-components/macro';
import { EachPageWithThumbnail } from 'store/models/file-selected/file-selected.interface';
import DestThumbnail from './DestThumbnail';

// PDFObject.embed(<byte array>, "#pdfObjectViewer");
interface DestThumbnailListProps {
  thumbnails: EachPageWithThumbnail[];
  destFileIndex?: number;
}

const DestThumbnailList: React.FC<DestThumbnailListProps> = ({
  thumbnails,
  destFileIndex,
}) => {
  const allUrls = useMemo(
    () => thumbnails && thumbnails.map((t) => t.thumbnail.pdfUrl),
    [thumbnails],
  );

  return (
    <ThumbnailsWrapper>
      {!thumbnails.length ? (
        <SNoThumbnail>No pages selected</SNoThumbnail>
      ) : (
        [
          <DestThumbnail
            key={`placeholder-${destFileIndex}`}
            destPageNo={0}
            destFileIndex={destFileIndex}
          />,
          thumbnails.map((thumbnail, index) => (
            <DestThumbnail
              key={`${thumbnail.partId}-${thumbnail.pageNo}-${index}`}
              thumbnail={thumbnail}
              destPageNo={index + 1}
              totalPages={thumbnails.length}
              destFileIndex={destFileIndex}
              index={index}
              allUrls={allUrls}
            />
          )),
        ]
      )}
    </ThumbnailsWrapper>
  );
};

export default DestThumbnailList;

const ThumbnailsWrapper = styled.div`
  margin-top: 0.2rem;
  display: flex;
  flex-wrap: wrap;
  column-gap: 0.5rem;
  row-gap: 0.5rem;
`;

const SNoThumbnail = styled.div`
  text-align: center;
  font-size: ${(props) => props.theme.typography.fontSize.body};
  line-height: ${(props) => props.theme.typography.lineHeight.title};
  color: ${(props) => props.theme.palette.text.secondary};
  background: ${(props) => props.theme.palette.grey[50]};
`;
